import React, { createContext, useContext, useState } from 'react';

const MessageContext = createContext();

export const MessageProvider = ({ children }) => {
  const [messages, setMessages] = useState([]);

  const addMessage = (message) => {
    setMessages((prev) => [...prev, message]);
  };

  const updateMessage = (id, newMessage) => {
    setMessages((prev) =>
      prev.map((msg) => (msg.id === id ? { ...msg, ...newMessage } : msg))
    );
  };

  const clearMessages = () => setMessages([]);

/*   console.log(messages) */

  return (
    <MessageContext.Provider value={{ messages, addMessage, updateMessage, clearMessages }}>
      {children}
    </MessageContext.Provider>
  );
};

export const useMessages = () => useContext(MessageContext);
